import { render, staticRenderFns } from "./usingStatistics.vue?vue&type=template&id=25af8704&scoped=true"
import script from "./usingStatistics.vue?vue&type=script&lang=js"
export * from "./usingStatistics.vue?vue&type=script&lang=js"
import style0 from "./usingStatistics.vue?vue&type=style&index=0&id=25af8704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af8704",
  null
  
)

export default component.exports